import React, { useEffect, useState } from "react";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { stripHtmlTags } from "../../utils/commonFunctions";

const CollapsibleWrapper = ({
  desc,
  descStyle,
  btnStyle,
  visibleLength,
  collapseBtnTitle = "Read less",
  expandBtnTitle = "Read more",
  visibleLines = "4",
  type = "mobile-only",
  wrapperContainer = "",
  readMoreStyle = "",
  readMoreBtnArrowStyle = "stroke-black-lighter dark:stroke-white transition ease-in-out duration-300",
  readMoreAdditionalStyle = "",
  summary,
  readMoreState = false,
  displayFullDesc = false
}) => {
  const breakpoint = useBreakpoint();
  const [readMore, setReadMore] = useState(false);
  const linkName = readMore ? collapseBtnTitle : expandBtnTitle;
  useEffect(() => {
    if (
      breakpoint !== "xs" &&
      (type === "mobile-only" || type === "both") &&
      readMoreState
    )
      setReadMore(true);
    else setReadMore(false);
  }, [breakpoint, readMoreState, type]);

  const noHtmlDesc = stripHtmlTags(desc);
  const summaryContent =
    displayFullDesc === true
      ? desc
      : summary && readMore === false
        ? summary
        : noHtmlDesc?.substring(0, visibleLength);
  const fullContent = desc;

  return (
    <div className={wrapperContainer}>
      <div
        className={`${descStyle} ${
          readMore
            ? `line-clamp-none ${readMoreStyle}`
            : `line-clamp-${visibleLines} ${readMoreAdditionalStyle}`
        }`}
        dangerouslySetInnerHTML={{
          __html: readMore === false ? summaryContent : fullContent
        }}
      />

      {displayFullDesc === false &&
        ((breakpoint === "xs" && (type === "mobile-only" || type === "both")) ||
          (breakpoint !== "xs" && type !== "mobile-only")) &&
        (fullContent?.length > visibleLength ||
          (noHtmlDesc?.length > summaryContent?.length &&
            fullContent?.length > summaryContent?.length)) && (
          <button className={btnStyle} onClick={() => setReadMore(!readMore)}>
            {linkName}
          </button>
        )}
    </div>
  );
};

export default CollapsibleWrapper;
